module.exports = __webpack_public_path__ + "static/media/24UHCHR10.71c903fd.jpg";